var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mapStar",
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mapStar",
    d: "m19.964 1.497 4.399 10.953a1.5 1.5 0 0 0 1.29.938l11.776.799a.5.5 0 0 1 .287.882l-9.058 7.568a1.5 1.5 0 0 0-.493 1.517l2.88 11.447a.5.5 0 0 1-.75.545l-9.997-6.276a1.5 1.5 0 0 0-1.596 0l-9.996 6.276a.5.5 0 0 1-.75-.545l2.879-11.447a1.5 1.5 0 0 0-.493-1.517L1.284 15.07a.5.5 0 0 1 .287-.883l11.776-.798a1.5 1.5 0 0 0 1.29-.938l4.399-10.953a.5.5 0 0 1 .928 0Z",
    fill: "#fff",
    stroke: "#fff"
  })));
};
export default SvgIconStar;